import React, { useState } from 'react';
import { Button } from 'reactstrap';
import __ from 'utils/i18n';
import { useSelector } from 'react-redux';
import { fetchResourceRP } from '../../../_shared/fetchResourceRP';
import { exportSubscribersReport } from '../../_shared/resources';
import { notification } from 'utils/notifications';

export const SubscribersReportWidget = ({ currentFilters = {} }) => {
  const { token } = useSelector((state) => state.api);
  const [isLoading, setIsLoading] = useState(false);

  const downloadReport = async () => {
    setIsLoading(true);
    try {
      const params = { ...currentFilters };

      const response = await fetchResourceRP(exportSubscribersReport(token), params);

      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `reporte_suscriptores_${new Date().getTime()}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      notification.success(__('dashboard.sections.recurringPayments.subscribers.report.success'));
    } catch (error) {
      console.error('[SubscribersReportWidget] Error downloading report:', error);
      notification.error(__('dashboard.sections.recurringPayments.subscribers.report.error'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="actions-header">
      <Button
        className="buttom-radius action__create-item d-flex align-items-center"
        onClick={downloadReport}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <i className="mdi mdi-loading mdi-spin mr-2" />
            {__('states.loading')}
          </>
        ) : (
          __('dashboard.sections.recurringPayments.subscribers.actions.generateReport')
        )}
      </Button>
    </div>
  );
};
